import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { BaseResponse } from "../objects/common/baseResponse";
import {Http, RequestOptions } from "@angular/http";
import {ConfigService} from "./configService";
import { PageVisit } from "../objects/pages/pageVisit";

@Injectable()
export class PageVisitService extends BaseApi {

    constructor(protected http: Http,
                protected configService: ConfigService) {
        super(http, configService);
    }

    public add(pageVisit: PageVisit): Promise<BaseResponse<any>> {
        return this.post(new RequestOptions({
            url: `pagevisit?pageTitle=${pageVisit.pageTitle}&pageOrder=${pageVisit.pageOrder}`
        }));
    }
}



// WEBPACK FOOTER //
// ./app/services/pageVisitService.ts